import { Context, Effect } from 'effect'

export type RuntimeDefectReporterService = {
  report: (context: string, error: unknown) => Effect.Effect<void>
}

/**
 * Reports failures from intentionally detached fibers to the owning store.
 *
 * Detached work cannot fail its already-completed parent effect. Package
 * runtimes use this service only at those ownership boundaries so defects
 * still reach the store's ordinary `onError` integration.
 */
export class RuntimeDefectReporter extends Context.Service<
  RuntimeDefectReporter,
  RuntimeDefectReporterService
>()('RuntimeDefectReporter') {}
